import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  addTagsButton: {
    marginTop: theme.spacing(4),
  },
}));
